import PolicyDependentButton from 'components/molecules/PolicyDependentButtons/PolicyDependentButton';
import {
  ProjectStatus,
  useShortlistStageDeleteMutation,
} from 'generated/graphql';
import { Reference } from '@apollo/client';
import {
  Button,
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';

export default function DeleteShortlistStageButton({
  projectStatus,
  disabled,
  shortlistStageSubId,
  projectId,
}: {
  projectStatus: ProjectStatus;
  disabled?: boolean;
  shortlistStageSubId: string;
  projectId: number;
}) {
  const { handleMsgType } = useNotification();
  const [deleteShortlistStage, { loading }] = useShortlistStageDeleteMutation({
    variables: {
      subId: shortlistStageSubId,
    },
    onCompleted: () => {
      handleMsgType({
        type: TNotification.success,
        title: 'Successfully removed shortlist stage',
        dismissable: true,
      });
    },
    onError: error => {
      handleMsgType({ type: TNotification.error, message: error?.message });
    },
    update: (cache) => {
      cache.modify({
        id: `Project:${projectId}`,
        fields: {
          shortlistStages(existingShortlistStages = [], { readField }) {
            return existingShortlistStages.filter(
              (shortlistRef: Reference) => shortlistStageSubId !== readField("subId", shortlistRef)
            );
          }
        },
      });
      cache.gc();
    }
  });

  const handleDelete = () => {
    deleteShortlistStage();
  };

  return (
    <PolicyDependentButton
      id="stage-header__delete-shortlist-stage-button"
      projectStatus={projectStatus}
      disabled={
        disabled
      }
      renderItem={disabled => (
        <Button
          onClick={handleDelete}
          size="medium"
          disabled={disabled || loading}
          loading={loading}
        >
          Remove
        </Button>
      )}
    />
  );
}